import { api } from "../../../infra/api";
import { URLS } from "../../../infra/URLS";

export async function getArquivos(ClienteId: number): Promise<any | any> {
  const resultJson = await api
    .get(`${URLS.ARQUIVOS_LISTA_API}?ClienteId=${ClienteId}`)
    .then((resp) => resp.data);
  return resultJson;
}